<p-button
  pButtonUtility
  [icon]="icon()"
  [disabled]="disabled"
  [styleClass]="styleClass()"
  [pTooltip]="tooltip() | transloco"
  [badge]="badge() ? badge()!.toString() : undefined"
  badgeSeverity="danger"
  tooltipPosition="bottom"
  (click)="menu.toggle($event)"
/>
<p-menu
  [model]="primeMenuItems()"
  [popup]="true"
  [appendTo]="appendTo()"
  #menu
>
  <ng-template
    #item
    let-item
  >
    <div
      class="flex items-center gap-2 cursor-pointer transition-colors px-2 py-2"
      [style.background-color]="selectedItem()?.value === item.id ? 'bg-neutral-50' : ''"
      [class.font-medium]="selectedItem()?.value === item.id"
    >
      @if (item.icon) {
        <i [class]="item.icon"></i>
      }
      <span class="text-sm">{{ item.label | transloco }}</span>
    </div>
  </ng-template>
</p-menu>
